import _sortBy from 'lodash/sortBy';

import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { carrierInfoState } from './carrierInfoState';

import { CarrierInformation } from 'app/services/api/models/CarrierInformation';

export const carrierInfoSlice = createSlice({
  name: 'carrierInfo',
  initialState: carrierInfoState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setDataReset: state => {
      state.isRequestPending = false;
      state.carrierInformation = [];
    },
    setCarrierInformation: (
      state,
      action: PayloadAction<Array<CarrierInformation>>,
    ) => {
      state.carrierInformation = action.payload;
    },
    setEditDeleteCarrierInformation: (
      state,
      action: PayloadAction<CarrierInformation | null>,
    ) => {
      state.editDeleteCarrierInformation = action.payload;
    },
    // API request statuses
    setIsRequestPending: (state, action: PayloadAction<boolean>) => {
      state.isRequestPending = action.payload;
    },
    setIsCreateUpdateCarrierInfoRequestPending: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isCreateUpdateCarrierInfoRequestPending = action.payload;
    },
    setIsDeleteCarrierInfoRequestPending: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isDeleteCarrierInfoRequestPending = action.payload;
    },
    // Toggle modal state
    setIsToggleCreateEditCarrierInfoModal: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isToggleCreateEditCarrierInfoModal = action.payload;
    },
    setIsToggleDeleteCarrierInfoModal: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isToggleDeleteCarrierInfoModal = action.payload;
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: carrierInfoActions } = carrierInfoSlice;

/* ------- STATE SELECTORS ------- */
export const selectCarrierInfo = (state: RootState) =>
  state.carrierInfo || carrierInfoState;

export const makeSelectCarrierInformation = () =>
  createSelector(selectCarrierInfo, carrierInfo =>
    _sortBy(carrierInfo.carrierInformation, ['carrierName']),
  );

// API REQUEST STATUSES
export const makeSelectIsRequestPending = () =>
  createSelector(
    selectCarrierInfo,
    carrierInfo => carrierInfo.isRequestPending,
  );

export const makeSelectEditDeleteCarrierInformation = () =>
  createSelector(
    selectCarrierInfo,
    carrierInfo => carrierInfo.editDeleteCarrierInformation,
  );

export const makeSelectCreateUpdateCarrierInfoRequestPending = () =>
  createSelector(
    selectCarrierInfo,
    carrierInfo => carrierInfo.isCreateUpdateCarrierInfoRequestPending,
  );

export const makeSelectDeleteCarrierInfoRequestPending = () =>
  createSelector(
    selectCarrierInfo,
    carrierInfo => carrierInfo.isDeleteCarrierInfoRequestPending,
  );

// TOGGLE MODAL STATUSES
export const makeSelectToggleCreateEditCarrierInfoModal = () =>
  createSelector(
    selectCarrierInfo,
    carrierInfo => carrierInfo.isToggleCreateEditCarrierInfoModal,
  );

export const makeSelectToggleDeleteCarrierInfoModal = () =>
  createSelector(
    selectCarrierInfo,
    carrierInfo => carrierInfo.isToggleDeleteCarrierInfoModal,
  );

export default carrierInfoSlice.reducer;
